import React from 'react'
import { CompanyModel, UserModel } from '~/types'
import { ProfileEditableText } from '~/pages/profile/ProfileEditableText'
import { Html, Maybe } from '~/api/generated/graphql'

type Props = {
  user: UserModel
  company: CompanyModel
  roleAtCompany?: Maybe<Html>
  modifiedTime?: Date
  canEdit: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveRole: (newContent: Maybe<Html>) => Promise<any>
  isOwnProfile?: boolean
}

export const ProfileRoleAtCompany = ({
  user,
  company,
  roleAtCompany,
  modifiedTime,
  canEdit,
  saveRole,
  isOwnProfile,
}: Props) => {
  return (
    <ProfileEditableText
      user={user}
      headerText={`${user.firstName}'s Role at ${company.name}`}
      modifiedTime={modifiedTime}
      content={roleAtCompany}
      canEdit={canEdit}
      saveContent={saveRole}
      isOwnProfile={isOwnProfile}
      placeHolder={`Please describe a bit about your role at ${company.name}`}
      companyId={company.companyId}
    />
  )
}
